<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none btn btn-link" type="button" @click="mobileSidebarToggle" style="height: 100%;">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- <b-link class="navbar-brand" to="#"></b-link> -->
    <button class="navbar-toggler sidebar-toggler d-md-down-none btn btn-link" type="button" @click="sidebarToggle" style="height: 100%;">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div>
      <!-- <img src="static/img/avatars/AsSpotlight.png" height="50px"> -->
      <strong class="h6">A's 3D Player</strong>
    </div>
    <!-- <b-navbar-nav class="d-md-down-none">
      <b-nav-item class="px-3">Dashboard</b-nav-item>
      <b-nav-item class="px-3">Users</b-nav-item>
      <b-nav-item class="px-3">Settings</b-nav-item>
    </b-navbar-nav> -->
    <b-navbar-nav class="ml-auto">
      <div>
        <strong class="h6">{{ loginname }}</strong>
      </div>
      <!-- <b-nav-item class="d-md-down-none">
        <i class="icon-bell"></i>
        <b-badge pill variant="danger">5</b-badge>
      </b-nav-item> -->
      <!-- <b-nav-item class="d-md-down-none">
        <i class="icon-list"></i>
      </b-nav-item> -->
      <!-- <b-nav-item class="d-md-down-none">
        <i class="icon-location-pin"></i>
      </b-nav-item> -->
      <HeaderDropdown/>
    </b-navbar-nav>
    <!-- <button class="navbar-toggler aside-menu-toggler d-md-down-none" type="button" @click="asideToggle">
      <span class="navbar-toggler-icon"></span>
    </button> -->
  </header>
</template>
<script>
import HeaderDropdown from './HeaderDropdown.vue'
import Store from '@/store'

export default {
  name: 'c-header',
  components: {
    HeaderDropdown
  },
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  },
  data () {
    return {
      loginname: Store.state.companyid
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header/Header.vue